module.exports = __webpack_public_path__ + "static/media/22ESCWA22.caee3e53.jpg";